import React, { Component, PropTypes } from 'react';

class PagesTeaser extends Component {
    render() {
        return (
            <div>
                Content of PagesTeaser
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesTeaser.propTypes = {
    children: PropTypes.element
};

export default PagesTeaser;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesTeaser.js